// Coordinates are approximate lat/lng, mapped to an equirectangular SVG (viewBox 0 0 1000 500)
// x = (lng + 180) * (1000/360), y = (90 - lat) * (500/180)
export const activeMarkets = [
    { code: "MU", name: "Mauritius", lat: -20.35, lng: 57.55 },
    { code: "BN", name: "Brunei", lat: 4.54, lng: 114.73 },
    { code: "MY", name: "Malaysia", lat: 4.21, lng: 101.98 },
    { code: "SG", name: "Singapore", lat: 1.35, lng: 103.82 },
    { code: "OM", name: "Oman", lat: 21.47, lng: 55.98 },
];

export const expansionMarkets = [
    { code: "AE", name: "UAE", lat: 23.42, lng: 53.85 },
    { code: "SA", name: "Saudi Arabia", lat: 23.89, lng: 45.08 },
    { code: "QA", name: "Qatar", lat: 25.35, lng: 51.18 },
    { code: "KW", name: "Kuwait", lat: 29.31, lng: 47.48 },
    { code: "BH", name: "Bahrain", lat: 26.07, lng: 50.55 },
    { code: "US", name: "USA", lat: 39.82, lng: -98.58 },
    { code: "CA", name: "Canada", lat: 56.13, lng: -106.35 },
    { code: "GB", name: "United Kingdom", lat: 55.38, lng: -3.44 },
    { code: "DE", name: "Germany", lat: 51.16, lng: 10.45 },
    { code: "FR", name: "France", lat: 46.23, lng: 2.21 },
    { code: "AU", name: "Australia", lat: -25.27, lng: 133.77 },
    { code: "ZA", name: "South Africa", lat: -30.56, lng: 22.94 },
    { code: "NG", name: "Nigeria", lat: 9.08, lng: 8.68 },
    { code: "KE", name: "Kenya", lat: -0.02, lng: 37.9 },
    { code: "ID", name: "Indonesia", lat: -0.79, lng: 113.92 },
    { code: "TH", name: "Thailand", lat: 15.87, lng: 100.99 },
    { code: "VN", name: "Vietnam", lat: 14.06, lng: 108.28 },
];

export const projectToSvg = ({ lat, lng }, w = 1000, h = 500) => {
    const x = (lng + 180) * (w / 360);
    const y = (90 - lat) * (h / 180);
    return { x, y };
};
